export default __webpack_public_path__ + "static/media/us.14abad61.svg";